import React from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import { palette } from '../../../palette';
import { theme } from '../../theme';
import styles from '../orderInfo/styles';
import OrderDetailsBox from '../orderInfo/orderDetailsBox';
import moment from 'moment';
import RepeatIcon from "@mui/icons-material/Repeat";

const ReturnTripDetailsBox = ({ returnTripService, fromName, fromAddress, toName, toAddress }) => {
  if (!returnTripService) return null;

  // Format dates in local time
  const formatTime = (dateString) => {
    if (!dateString) return 'N/A';
    const utcDate = moment.utc(dateString).toDate();
    return moment(utcDate).local().format('YYYY-MM-DD HH:mm');
  };

  // Format currency
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return 'N/A';
    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'CAD' 
    }).format(amount);
  };

  return (
    <div style={{ ...styles.orderContainer, backgroundColor: '#E1F1FF90' }}>
      <Grid container direction="row" alignItems="stretch" spacing={2}>

        <Grid item xs={12}>
          <Typography style={styles.sectionTitle}>RETURN TRIP</Typography>
        </Grid>

        {/* Return times */}
        {[
          { label: 'RETURN PICKUP TIME',   value: formatTime(returnTripService.dtPickupStart) },
          { label: 'RETURN DELIVERY TIME', value: formatTime(returnTripService.dtDeliveryEnd) },
        ].map(({ label, value }) => (
          <Grid item xs={12} sm={6} key={label}>
            <div style={styles.addressCard}>
              <Typography style={styles.addressCardLabel}>{label}</Typography>
              <Divider style={{ marginBottom: 6 }} />
              <Typography style={styles.addressCardName}>{value}</Typography>
            </div>
          </Grid>
        ))}

        {/* Return FROM */}
        <Grid item xs={12} sm={6}>
          <div style={styles.addressCard}>
            <Typography style={styles.addressCardLabel}>RETURN FROM</Typography>
            <Divider style={{ marginBottom: 6 }} />
            <Typography style={styles.addressCardName}>{toName}</Typography>
            <Typography style={styles.addressCardValue}>{toAddress}</Typography>
          </div>
        </Grid>

        {/* Return TO */}
        <Grid item xs={12} sm={6}>
          <div style={styles.addressCard}>
            <Typography style={styles.addressCardLabel}>RETURN TO</Typography>
            <Divider style={{ marginBottom: 6 }} />
            <Typography style={styles.addressCardName}>{fromName}</Typography>
            <Typography style={styles.addressCardValue}>{fromAddress}</Typography>
          </div>
        </Grid>

      </Grid>
    </div>
  );
};

export default ReturnTripDetailsBox;
